<template>
  <h2
    class="my-5 underline break-all"
  >
    Component name: {{ name }}
  </h2>
</template>

<script lang="ts">
export default defineComponent({
  name: 'ComponentName',
  props: {
    name: {
      type: String,
      required: true,
    },
  },
});

</script>
